import Image from "next/image";
import { useState } from "react";
import GenericMaleThumbnail from "../../../../../public/images/thumbs-generic-male-1.png";
import GenericFemaleThumbnail from "../../../../../public/images/thumbs-generic-female-1.png";
import { ProgressBarWidget } from "../../../ProgressBar";
import styles from "../../../../styles/races/national/MapResultsCandidates.module.scss";

const MapResultsCandidates = ({
  location,
  candidatesList,
  contestName,
  candidateFilter,
  selectAllCandidates,
  selectTop5,
  description,
  onCandidateSelect,
  timestamp,
  voteCount,
  transmissionPercentage
}) => {

  const onSelectAll = (filter) => {
    selectAllCandidates(filter);
  }

  const onSelectTop5 = () => {
    selectTop5();
  }

  const ImageWithFallback = (props) => {
    const { altSrc, src, fallbackSrc, ...config } = props;
    const [imgSrc, setImgSrc] = useState(src);
  
    return (
      <Image
        {...config}
        alt={altSrc}
        src={imgSrc}
        onError={() => setImgSrc(fallbackSrc)}
      />
    );
  };
  
  const loader = ({ src, width, quality }) => {
    return `${src}?w=${width}&q=${quality || 75}`;
  };

  const renderCandidateList = () => {
    return (
      <div className={styles.electionRaceContainer_candidates_results}>
        <div className={styles.titleContainer}>
          <div className={styles.resultsTitle}>
            <h6>Rank</h6>
            <h6>Candidates</h6>
          </div>
          <div className={styles.resultsTitle}>
            <h6>Votes</h6>
            <h6>Percent</h6>
          </div>
        </div>
        <ol>
          {candidatesList &&
            candidatesList
              .map((res, index) => (
                <li key={index} onClick={() => onCandidateSelect(res)}>
                  <div className={styles.candidate_container} style={{ backgroundColor: res.selected ? "#F5F6FF" : "#FFF" }}>
                    <div className={styles.candidateDetails}>
                      <h4 className={styles.rank}> {res.rank ? res.rank : ""} </h4>
                      <div className={styles.candidate} style={{ borderRadius: "50%", border: res.selected ? `5px solid ${res.color}` : "5px solid transparent" }}>
                        <ImageWithFallback
                          loader={loader}
                          src={
                            res.thumbnail !== null
                              ? res.thumbnail
                              : (res.gender || "").toLowerCase() === "female"
                              ? GenericFemaleThumbnail
                              : GenericMaleThumbnail
                          }
                          fallbackSrc={
                            (res.gender || "").toLowerCase() === "female"
                              ? GenericFemaleThumbnail
                              : GenericMaleThumbnail
                          }
                          altSrc={`${res.raw_name}`}
                          layout="fixed"
                          width={70}
                          height={70}
                        />
                      </div>
                      <div className={styles.detailsContainer}>
                        <div className={styles.detailsWrapper}>
                          <ul className={styles.details}>
                            <h3 className={styles.name}>
                              {res.raw_name.split(/[,.]/)[0]}
                              <span
                                data-text={`
                              ${res.raw_name
                                .split(/[()]+/)[0]
                                .trim()
                                .split(/[,.]/)
                                .slice(1, 3)
                                .join()}
                              (${
                                res.raw_name
                                  .split(/[()]+/)
                                  .filter(function (e) {
                                    return e;
                                  })[1]
                              })`}
                              />
                            </h3>
                          </ul>
                          <div className={styles.votesDetails}>
                            <p className={styles.votes}>{res.votes.toLocaleString()}</p>
                            <p className={styles.percent}>{res.percentage}%</p>
                          </div>
                        </div>
                        <div className={styles.progressDesktop}>
                          <ProgressBarWidget percentage={res.percentage} />
                        </div>
                      </div>
                    </div>
                    <div className={styles.progressMobile}>
                      <ProgressBarWidget percentage={res.percentage} />
                    </div>
                  </div>
                </li>
            ))}
        </ol>
      </div>
    );
  };

  return (
    <div className={styles.electionRaceContainer}>
      <div className={styles.containerHeader}>
        <div className={styles.titleSubWrapper}>
          <div>
            <h2 className={styles.containerHeader_title}>{location === "Philippines" ? `${location}*` : location}</h2>
            <h3 className={styles.containerHeader_subtitle}>{contestName}</h3>
          </div>
        </div>
        { location === "Philippines" &&
          <p className={styles.containerHeader_description}>
            * IMPORTANT: Total count as of <b>{timestamp}</b> includes total of <b>{voteCount.toLocaleString()}</b> votes from <b>{transmissionPercentage}</b>% precincts of <b>Overseas Absentee Votes</b>
          </p>
        }
        <p> { description } </p>
      </div>
      <div className={styles.pills}>
        <div
          className={
            contestName === "President"
              ? candidateFilter[0] === "all"
                ? styles.active
                : ""
              : candidateFilter[1] === "all"
              ? styles.active
              : ""
          }
          onClick={() => onSelectAll(true)}
        >
          Select All
        </div>
        <div
          className={
            contestName === "President"
              ? candidateFilter[0] === "top-5"
                ? styles.active
                : ""
              : candidateFilter[1] === "top-5"
              ? styles.active
              : ""
          }
          onClick={() => onSelectTop5()}
        >
          Top 5 Candidates
        </div>
        <div
           className={
            contestName === "President"
              ? candidateFilter[0] === "clear"
                ? styles.active
                : ""
              : candidateFilter[1] === "clear"
              ? styles.active
              : ""
          }
          onClick={() => onSelectAll(false)}
        >
          Clear Selection
        </div>
      </div>

      {renderCandidateList()}
    </div>
  );
};

export default MapResultsCandidates;
